import React, { useContext } from 'react'
import { observer } from 'mobx-react-lite'
import { CalendarWeek } from 'react-bootstrap-icons'
import { TimelineContext } from '../../../../../../contexts/TimelineContext'
import Button from '../../../../../Shared/Button'

export default observer(function TimelineSidebarDurationToggle() {
  const { readonly, timelineState } = useContext(TimelineContext)
  if (readonly) return null

  const showDates = timelineState.sidebarShowAssetDates

  return (
    <Button
      type="button"
      size="sm"
      variant={showDates ? 'primary' : 'outlinePrimary'}
      aria-pressed={showDates}
      onClick={() => timelineState.toggleSidebarShowAssetDates()}
      className="mt-2 inline-flex w-fit items-center gap-2 text-left self-start"
    >
      <CalendarWeek className="h-4 w-4 shrink-0 opacity-90" aria-hidden />
      Duration
    </Button>
  )
})
